
// Gallery
import Gallery1 from "../assets/gallery/gallery1.png";
import Gallery2 from "../assets/gallery/gallery2.png";
import Gallery3 from "../assets/gallery/gallery3.png";
import Gallery4 from "../assets/gallery/gallery4.png";
import Gallery5 from "../assets/gallery/gallery5.png";
import Gallery6 from "../assets/gallery/gallery6.png";
import Gallery7 from "../assets/gallery/gallery7.png";
import Gallery8 from "../assets/gallery/gallery8.png";
import Gallery9 from "../assets/gallery/gallery9.png";
import Gallery10 from "../assets/gallery/gallery10.jpg";
import Gallery11 from "../assets/gallery/gallery11.png";
import Gallery12 from "../assets/gallery/gallery12.jpg";
import Gallery13 from "../assets/gallery/gallery13.jpg";
import Gallery14 from "../assets/gallery/gallery14.avif";
import Gallery15 from "../assets/gallery/gallery15.avif";
import Gallery16 from "../assets/gallery/gallery16.jpeg";
import Gallery17 from "../assets/gallery/gallery17.jpg";
import Gallery18 from "../assets/gallery/gallery18.webp";
import Gallery19 from "../assets/gallery/gallery19.jpeg";
import Gallery20 from "../assets/gallery/gallery20.jpeg";
import Gallery21 from "../assets/gallery/gallery21.jpeg";
import Gallery22 from "../assets/gallery/gallery22.jpeg";
import Gallery23 from "../assets/gallery/gallery23.jpg";
import Gallery24 from "../assets/gallery/gallery24.jpg";
import Gallery25 from "../assets/gallery/gallery25.jpg";
import Gallery26 from "../assets/gallery/gallery26.jpg";
import Gallery27 from "../assets/gallery/gallery27.jpg";
import Gallery28 from "../assets/gallery/gallery28.jpg";
import Gallery29 from "../assets/gallery/gallery29.jpg";
import Gallery30 from "../assets/gallery/gallery30.jpg";
import Gallery31 from "../assets/gallery/gallery31.jpg";
import Gallery32 from "../assets/gallery/gallery32.jpg";
import Gallery33 from "../assets/gallery/gallery33.jpg";
import Gallery34 from "../assets/gallery/gallery34.jpg";
import Gallery35 from "../assets/gallery/gallery35.jpg";
import Gallery36 from "../assets/gallery/gallery36.jpg";
import Gallery37 from "../assets/gallery/gallery37.jpg";
import Gallery38 from "../assets/gallery/gallery38.jpg";
import Gallery39 from "../assets/gallery/gallery39.jpg";
import Gallery40 from "../assets/gallery/gallery40.jpg";
import Gallery41 from "../assets/gallery/gallery41.jpg";
import Gallery42 from "../assets/gallery/gallery42.jpg";
import Gallery43 from "../assets/gallery/gallery43.jpg";
import Gallery44 from "../assets/gallery/gallery44.jpg";
import Gallery45 from "../assets/gallery/gallery45.jpg";
import Gallery46 from "../assets/gallery/gallery46.jpg";
import Gallery47 from "../assets/gallery/gallery47.jpg";
import Gallery48 from "../assets/gallery/gallery48.jpg";




const kumbhGalleryData = {
  Gallery: [Gallery1, Gallery2, Gallery3, Gallery4, Gallery5, Gallery6, Gallery7, Gallery8, Gallery9, Gallery10, Gallery11, Gallery12, Gallery13, Gallery14, Gallery15, Gallery16, Gallery17, Gallery18, Gallery19, Gallery20, Gallery21, Gallery22, Gallery23, Gallery24, Gallery25, Gallery26, Gallery27, Gallery28, Gallery29, Gallery30, Gallery31, Gallery32, Gallery33, Gallery34, Gallery35, Gallery36, Gallery37, Gallery38, Gallery39, Gallery40, Gallery41, Gallery42, Gallery43, Gallery44, Gallery45, Gallery46, Gallery47, Gallery48]
};

export default kumbhGalleryData;
